import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LegalPage } from './app.types';

@Component({
  selector: 'app-legal-page',
  standalone: false,
  template: `
    <main class="legal-page" *ngIf="page">
      <div class="legal-page__header">
        <ion-button size="small" fill="clear" (click)="closePage.emit()">Back to Wahl Advertising</ion-button>
        <span>Updated {{ page.updated }}</span>
      </div>

      <h1>{{ page.title }}</h1>

      <section *ngFor="let section of page.sections">
        <h2>{{ section.heading }}</h2>
        <p *ngFor="let paragraph of section.paragraphs">{{ paragraph }}</p>
      </section>
    </main>
  `
})
export class LegalPageComponent {
  @Input() page: LegalPage | null = null;
  @Output() closePage = new EventEmitter<void>();
}
